import { CsError } from "../../../../../logic/CsError"
import { BasePinErrorDialog } from "./BasePinErrorDialog"

export function GenericPinErrorDialog({ error } : { error: Error | CsError} ) {
  let errorMessage

  if (error instanceof CsError && error.userErrorMessage) {
    errorMessage = error.userErrorMessage
  } else if (error instanceof Error && error.message) {
    errorMessage = error.message
  } else {  //This should not be possible, but adding here incase types are wrong.
    errorMessage = 'An unknown error occurred.'
  }


  return BasePinErrorDialog(
    'Sorry, something went wrong',
    `${errorMessage}`
  )
}
